"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutPage = exports.LogoutPageConfig = void 0;
var tslib_1 = require("tslib");
var mithril_1 = require("../mithril");
var services_1 = require("../services");
var page_1 = require("./page");
exports.LogoutPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.logout,
    path: '/logout',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var LogoutPage = /** @class */ (function (_super) {
    tslib_1.__extends(LogoutPage, _super);
    function LogoutPage() {
        return _super.call(this, exports.LogoutPageConfig) || this;
    }
    Object.defineProperty(LogoutPage.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { onupdate: function () { return services_1.Services.User.logout(); }, oncreate: function () { return services_1.Services.User.logout(); } });
        },
        enumerable: false,
        configurable: true
    });
    return LogoutPage;
}(page_1.IkePage));
exports.LogoutPage = LogoutPage;
//# sourceMappingURL=logout.page.js.map